<template>
  <b-row>
    <b-col>
      <div class="report__report-buttons">
        <div class="report__buttons-wrapper no-internal-print">
          <b-button
            class="report__cancel-button"
            variant="secondary"
            @click="emitEvent(events.CANCEL)"
          >{{ $t('general.cancel') }}
          </b-button>

          <additional-fields
            v-if="showAdditionalFields"
            :tabs-to-show="sendAssetTypesByFilter"
            @fields-selected="emitSetAdditionalFields"
          />
        </div>

        <div class="report__buttons-wrapper no-internal-print">
          <b-btn
            class="mb-lg-0 mb-0 mx-lg-2"
            variant="outline-primary"
            :disabled="saveTemplateDisabled"
            @click="emitEvent(events.SAVE_TEMPLATE)"
          >
            <s-loader
              v-if="saveTemplateLoading"
              class="d-inline-flex"
            />
            <i
              v-else
              aria-hidden="true"
              class="fas fa-save mr-2"
            />
            {{ $t('reports.save-template') }}
          </b-btn>
          <b-dropdown
            class="report__dropdown-button"
            split
            variant="primary"
            :disabled="viewReportDisabled"
            :text="$t('reports.filters.view-report')"
            @click="emitEvent(events.VIEW_REPORT)"
          >
            <b-dropdown-item @click="emitEvent(events.EXPORT_XLSX)">
              <b-btn
                class="my-3 my-sm-0"
                variant="outline-primary"
                block
                :disabled="exportXlsxDisabled"
              >
                <s-loader
                  v-if="exportXlsxLoading"
                  class="report__xlsx-loading"
                />
                <i
                  v-else
                  class="fas fa-file-excel mr-1"
                  aria-hidden="true"
                />
                <span>{{ $t('general.export-xlsx') }}</span>
              </b-btn>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import AdditionalFields from '@/domain/components/generalPanel/reports/additionalFields/AdditionalFields';

const events = {
  CANCEL: 'cancel',
  SAVE_TEMPLATE: 'save-template',
  VIEW_REPORT: 'view-report',
  EXPORT_XLSX: 'export-xlsx',
};

export default {
  name: 'ReportFooterButons',
  components: {
    AdditionalFields,
  },
  props: {
    saveTemplateDisabled: {
      type: Boolean,
      required: true,
    },
    viewReportDisabled: {
      type: Boolean,
      required: true,
    },
    exportXlsxDisabled: {
      type: Boolean,
      required: true,
    },
    saveTemplateLoading: {
      type: Boolean,
      required: true,
    },
    exportXlsxLoading: {
      type: Boolean,
      required: true,
    },
    showAdditionalFields: {
      type: Boolean,
      default: false,
    },
    sendAssetTypesByFilter: {
      type: Array,
    },
  },
  data: () => ({
    events,
  }),
  methods: {
    emitEvent(event) {
      this.$emit(event);
    },
    emitSetAdditionalFields(event) {
      this.$emit('set-additional-fields', event);
    },
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.report
  &__buttons
    margin-top: 30px
    display: flex
    justify-content: space-between

  &__buttons-wrapper
    display: flex
    justify-content: flex-end
    margin-bottom: 15px

    +media-max-md
      & > button
        margin-bottom: 0.5rem !important

    ::v-deep
      .dropdown-menu.show
        padding: 0 !important
        width: 100% !important

      .dropdown-item
        padding: 0

        & > button
          margin-top: 0 !important
          margin-bottom: 0 !important

    +media-max-md
      flex-direction: column

  &__xlsx-loading
    display: inline-flex

.report__report-buttons
  display: inline-flex
  justify-content: space-between
  width: 100%

</style>
